import React from "react";
import classes from "./churchevent.module.css";
import ChurchEventTable from "../../../components/ChurchEventTable/ChurchEventTable";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ChurchEventDialog from "../../../components/FormDialog/ChurchEventDialog";
import useEvents from "../../../../hooks/useEvents";
import Searchbar from "../../../components/searchbar/Searchbar";

const ChurchEvent = () => {
   const { openEventsForm, searchEvents } = useEvents();
   return (
      <Box sx={{ width: "100%" }} className={classes.mainContent}>
         <div className={classes.buttons}>
            <Button
               onClick={openEventsForm}
               className={classes.button}
               variant="outlined"
            >
               Add Church Event +
            </Button>

            <ChurchEventDialog />
            <Searchbar label="Search events" onSearchFunction={searchEvents} />
         </div>
         <div className={classes.table}>
            <ChurchEventTable />
         </div>
      </Box>
   );
};

export default ChurchEvent;
